var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuotesStart(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 60,
    viewBox: "0 0 71 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M70.689 9.37C60.1 14.578 54.807 20.695 54.807 27.723c4.513.521 8.245 2.365 11.195 5.532 2.951 3.167 4.426 6.833 4.426 10.998 0 4.425-1.432 8.156-4.296 11.193C63.27 58.482 59.667 60 55.328 60c-4.86 0-9.069-1.974-12.627-5.922-3.558-3.948-5.337-8.742-5.337-14.382 0-16.92 9.46-30.151 28.378-39.696l4.947 9.37zm-37.364 0C22.65 14.578 17.313 20.695 17.313 27.723c4.6.521 8.375 2.365 11.325 5.532 2.951 3.167 4.426 6.833 4.426 10.998 0 4.425-1.453 8.156-4.36 11.193C25.795 58.482 22.173 60 17.833 60c-4.86 0-9.047-1.974-12.562-5.922C1.757 50.13 0 45.336 0 39.696 0 22.776 9.416 9.545 28.248 0l5.077 9.37z",
    fill: "#FFDC66"
  })));
}
export default SvgQuotesStart;